module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": _vm.title,
      "width": "560",
      "mask-closable": false,
      "transfer": ""
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 110,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "外教"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.tchText))]), _vm._v(" "), (_vm.row && _vm.row.country) ? _c('span', {
    staticClass: "muted"
  }, [_vm._v("· " + _vm._s(_vm.row.country))]) : _vm._e()]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "原合同期"
    }
  }, [_c('span', [_vm._v(_vm._s((_vm.row && _vm.row.crtBeginDate) || '—') + " ~ " + _vm._s((_vm.row && _vm.row.crtEndDate) || '—'))]), _vm._v(" "), (_vm.row && _vm.row.daysLeft != null) ? _c('span', {
    staticClass: "muted"
  }, [_vm._v("（" + _vm._s(_vm.daysLabel) + "）")]) : _vm._e()]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "新合同起始日",
      "required": ""
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "type": "date",
      "value": _vm.form.crtBeginDate,
      "clearable": false,
      "transfer": ""
    },
    on: {
      "on-change": _vm.onBeginChange
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "新合同到期日",
      "required": ""
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "type": "date",
      "value": _vm.form.crtEndDate,
      "clearable": false,
      "transfer": ""
    },
    on: {
      "on-change": function($event) {
        _vm.form.crtEndDate = $event
      }
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "maxlength": 1000,
      "placeholder": "续签年限、薪资调整、签署状态等"
    },
    model: {
      value: (_vm.form.note),
      callback: function($$v) {
        _vm.$set(_vm.form, "note", $$v)
      },
      expression: "form.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确认续签")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39031e1e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrWorkbench/modal/ContractRenewModal.vue
// module id = 1756
// module chunks = 8